import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import InvitedUsers from '@views/ManageAccount/AccessManagement/InvitedUsers';
import ManageAccountLayout from '@views/ManageAccount/ManageAccountLayout';

const messages = defineMessages({
  title: {
    id: 'manageAccount.accessManagement',
    defaultMessage: 'Access Management',
  },
});

export default function AccessManagementPage(props: PagePropsWithBreadcrumbs) {
  const { formatMessage } = useIntl();

  return (
    <ManageAccountLayout
      friendlyName={formatMessage(messages.title)}
      pageProps={props}
    >
      {({ user }) => <InvitedUsers ownerUser={user ?? undefined} />}
    </ManageAccountLayout>
  );
}
